import type { ProductSlot } from './types';

export type ProtectionLevel = 'full' | 'partial' | 'in_progress' | 'no_products';

export const isActiveStatus = (status: ProductSlot['status']): boolean => status === 'active';

export const isTerminatedStatus = (status: ProductSlot['status']): boolean => status === 'terminated';

export const isNotAddedStatus = (status: ProductSlot['status']): boolean =>
  status === null || isTerminatedStatus(status);

export const getProtectionLevel = (products: ProductSlot[]): ProtectionLevel => {
  if (products.length === 0) return 'no_products';

  const hasActive = products.some((p) => isActiveStatus(p.status));
  const hasNotAdded = products.some((p) => isNotAddedStatus(p.status));
  const hasInProgress = products.some((p) => !isActiveStatus(p.status) && !isNotAddedStatus(p.status));

  if (hasActive && !hasNotAdded && !hasInProgress) return 'full';
  if (hasActive) return 'partial';
  if (hasInProgress) return 'in_progress';
  return 'no_products';
};

export const groupProductsByStatus = (
  products: ProductSlot[],
): { actedUpon: ProductSlot[]; notAdded: ProductSlot[] } => ({
  actedUpon: products.filter((p) => !isNotAddedStatus(p.status)),
  notAdded: products.filter((p) => isNotAddedStatus(p.status)),
});
